<template>
  <div class="car">
    <div class="car-list">
      <van-checkbox-group v-model="result" @change="check" ref="checkboxGroup">
        <ul>
          <li v-for="(item2, index2) of stockList" :key="index2">

            <div class="item-head"><button @click="detelePro('stockList', item2)"> </button></div>
            <div class="item-content">
              <div>
                <van-checkbox :name="item2.cart_id" checked-color="#FF6161"></van-checkbox>
              </div>
              <div>
                <img v-if="item2.goods_pic" :src="item2.goods_pic || ''" alt="" />
              </div>
              <div class="pro-content">

                <div class="pro-name">{{ item2.goods_name }}</div>
                <div class="pro-price">
                  <div> {{ $setInfoDecimal(item2.goods_price) }} 积分</div>
                  <div>
                    <van-stepper v-model="item2.goods_num" theme="round" button-size="22" disable-input @change="
                        modifyCount(item2.goods_num, item2.goods_sn, index2)
                      " />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- <template #right>
              <van-button square text="删除" type="danger" class="delete-button" @click="detelePro('stockList', index2)" />
            </template>
          </van-swipe-cell> -->
        </ul>
        <!-- </van-checkbox-group> -->

        <ul class="out-stock">
          <!-- <van-swipe-cell v-for="(item2, index2) of outStockList" :key="index2"> -->
          <li v-for="(item2, index2) of outStockList" :key="index2">
            <div class="item-head"><button @click="detelePro('outStockList', index2)"> </button></div>
            <div class="item-content">

              <div>
                <van-checkbox :name="item2.cart_id" checked-color="#FF6161" :disabled="true"></van-checkbox>
              </div>
              <div class="goods_img">
                <img v-if="item2.goods_pic" :src="item2.goods_pic || ''" alt="" />
              </div>
              <div class="pro-content">
                <div class="pro-name">{{ item2.goods_name }}</div>
                <div class="pro-price">
                  <div> {{ $setInfoDecimal(item2.goods_price) }} 积分</div>
                </div>
              </div>
            </div>
          </li>
          <!-- <template #right>
            <van-button square text="删除" type="danger" class="delete-button" @click="detelePro('outStockList', index2)" />
          </template> -->
          <!-- </van-swipe-cell> -->
        </ul>
      </van-checkbox-group>
    </div>

    <!-- </div> -->

    <div class="bottom-total">
      <div class="total-left">
        <van-checkbox v-model="checked" @click="checkAll"><span style="color:#fff;">全选</span></van-checkbox>
        <div class="total">
          <p>所选 {{ $setInfoDecimal(total) }} 积分</p>
          <p>剩余 {{  surplus  }}</p>
        </div>
      </div>
      <div class="total-btn"><button @click="submit">提交</button></div>
    </div>
  </div>
</template>
<script>

import {
  SwipeCell,
  Button,
  Checkbox,
  CheckboxGroup,
  Stepper,
  Toast,
  Dialog
} from 'vant'
import { carlist, cartModify, cartDelete } from '@/api/car'
import { getUserInte } from '@/api/pay'

import paymentHandle from '@/utils/paymentHandle'


export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Stepper.name]: Stepper,
    [Dialog.name]: Dialog
  },
  data () {
    return {
      result: [],
      checked: false,
      freight: 0,
      datas: [],
      outStockList: [], // 无货列表
      stockList: [], // 有货列表,
      userInte: 0
    }
  },
  methods: {
    async getUserInte () {
      const result = await getUserInte()
      this.userInte = result.data.data.inte
    },
    async getlist () {
      const result = await carlist()
      if (result.data.data.status) {
        const list = result.data.data.cartList
        list.map((item) => {
          if (item.goods_status === 1) {
            this.stockList.push(item)
          }

          if (item.goods_status === 0) {
            this.result = this.result.filter(value => Number(value) !== Number(item.cart_id))
            this.outStockList.push(item)
          }
        })
      }
    },
    check () {
      if (this.result.length === this.stockList.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    // 全选
    checkAll () {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true)
      } else {
        this.$refs.checkboxGroup.toggleAll()
      }
    },
    async modifyCount (num, goods_sn, index) {
      const result = await cartModify({
        num,
        goods_sn,
      })
      if (result.data.data.status) {
        this.stockList[index].num = num
      }
    },
    submit () {
      if (this.result.length === 0) {
        Toast('请选择商品')
        return
      }
      paymentHandle.setPayment({
        [paymentHandle.api.payType]: paymentHandle.type.cart,
        [paymentHandle.api.payId]: `[${this.result}]`,
      })
      this.$router.push('/payment')
    },
    // 删除商品
    detelePro (type, item) {
      Dialog.confirm({
        title: '是否删除该商品',
      }).then(async () => {
        const result = await cartDelete({
          carts_id: item.carts_id,
          goods_sn: item.goods_sn,
        })

        this.$toast(result.data.data.message)

        if (result.data.data.status) {
        
          this.result = this.result.filter(value => Number(value) !== Number(item.cart_id))

          this[type] = this[type].filter(value => value.cart_id !== item.cart_id)
        }
      }).catch(() => {
      });
    },
    resetCartInfo () {
      this.outStockList = []
      this.stockList = []
      this.getlist()
      this.getUserInte()

    }
  },
  activated () {
    this.resetCartInfo()
  },
  computed: {
    total () {
      let total = 0
      this.stockList.map((item) => {
        if (
          this.result.find((value) => {
            return item.cart_id === value
          })
        ) {
          total += item.goods_num * item.goods_price
        }
      })
      return total
    },
    surplus () {
      return this.userInte - this.total >= 0 ? this.$setInfoDecimal(this.userInte - this.total) + ' 积分' : '积分不足'
    },
  },
  // mounted () {
  //   this.getlist()
  //   this.getUserInte()
  // },

}
</script>
<style lang="scss" scoped>
.car {
  font-size: 0.28rem;
  padding-bottom: env(safe-area-inset-bottom);
  margin-bottom: 4rem;
  .delete-button {
    height: 100%;
  }
  .car-list {
    ul {
      flex-direction: column;
      display: flex;
      align-items: center;
      li {
        width: 6.8rem;
        border-radius: 10px;
        margin: 0.1rem;
        background: white;
        padding: 0.1rem;
        .item-head {
          text-align: right;
          padding: 0.1rem;
          button {
            // margin: 0;
            background: url('../../assets/icon/delete.png') no-repeat;
            background-size: 0.3rem;
            width: 0.3rem;
            height: 0.3rem;
            padding: 0;
            color: rgb(255, 97, 97);
            border: 0;
          }
        }
        .item-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        img {
          width: 1.71rem;
          height: 1.71rem;
        }
        .pro-content {
          margin-left: 0.1rem;
          width: 3.8rem;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          height: 1.71rem;
          .pro-name {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .pro-price {
          display: flex;
          justify-content: space-between;
          font-weight: 600;
        }
        .pro-size {
          p {
            border: 1px solid #707070;
            border-radius: 30px;
            width: auto;
            display: inline-block;
            font-size: 0.16rem;
            padding: 0.02rem 0.1rem;
          }
        }
      }
    }
  }
}
.bottom-total {
  display: flex;
  background: white;
  justify-content: space-between;
  position: fixed;
  width: 96vw;
  margin: 0 2vw;
  bottom: 1rem;
  padding-bottom: env(safe-area-inset-bottom);

  .total-left {
    display: flex;
    justify-content: space-between;
    background: $globalcolor;
    width: 65%;
    padding: 0.1rem 0.2rem;
    border-radius: 10px;
  }
  .total-btn {
    button {
      padding: 0.2rem;
      background: rgb(255, 97, 97);
      color: white;
      width: 1.5rem;
      border-radius: 10px;
      border: none;
      height: 1.2rem;
    }
  }
  .total {
    p {
      margin: 0.09rem 0;
      color: #fff;
    }
  }
}

.pro-head {
  display: flex;
  justify-content: space-between;
  font-weight: 800;
  padding: 0 0.6rem;
  padding-top: 0.5rem;
}
.goods_img {
  position: relative;
  width: 1.71rem;
  height: 1.71rem;

  &::after {
    content: '已下架';
    font-size: 0.5rem;
    width: 1.71rem;
    height: 1.71rem;
    background: rgba($color: #eee, $alpha: 0.6);
    position: absolute;
    top: 0;
    left: 0;
    line-height: 1.71rem;
    text-align: center;
    color: #fff;
    // border-radius: 50%;
  }
}
.out-stock {
  margin-top: 0.2rem;
  background: #fff !important;
}
</style>